<template>
  <div class="floated-colors-btn third-floated-btn" @click="darkMode">
    <div class="os-toggler-w">
      <div class="os-toggler-i">
        <div class="os-toggler-pill"></div>
      </div>
    </div>
    <span>Dark </span><span>Color</span>
  </div>
</template>

<script>
export default {
  name: 'DarkColor',
  data () {
    return {
      //
    }
  },
  methods: {
    darkMode() {
      if ($('body').hasClass('color-scheme-dark')) {
        this.$root.isDarkMode = false;
        localStorage.setItem('dark-mode', 'off');
        $('.menu-w').removeClass('color-scheme-dark').addClass('color-scheme-light').removeClass('selected-menu-color-bright').addClass('selected-menu-color-light');
        $('body').find('.os-toggler-w').removeClass('on');
      } else {
        this.$root.isDarkMode = true;
        localStorage.setItem('dark-mode', 'on');
        $('.menu-w, .top-bar').removeClass(function (index, className) {
          return (className.match(/(^|\s)color-scheme-\S+/g) || []).join(' ');
        });
        $('.menu-w').removeClass(function (index, className) {
          return (className.match(/(^|\s)color-style-\S+/g) || []).join(' ');
        });
        $('.menu-w').addClass('color-scheme-dark').addClass('color-style-transparent').removeClass('selected-menu-color-light').addClass('selected-menu-color-bright');
        $('.top-bar').addClass('color-scheme-transparent');
        $('body').find('.os-toggler-w').addClass('on');
      }
      $('body').toggleClass('color-scheme-dark');
      return false;
    },
    checkDarkMode() {
      if (this.$root.isDarkMode) {
        setTimeout(() => {
          $('.menu-w').addClass('color-scheme-dark').removeClass('color-scheme-light').addClass('selected-menu-color-bright').removeClass('selected-menu-color-light');
          $('body').find('.os-toggler-w').addClass('on');
          $('body').addClass('color-scheme-dark');
        }, 100)
        return false;
      }

      if (localStorage.getItem('dark-mode') === 'on') {
        setTimeout(() => {
          $('.menu-w').addClass('color-scheme-dark').removeClass('color-scheme-light').addClass('selected-menu-color-bright').removeClass('selected-menu-color-light');
          $('body').find('.os-toggler-w').addClass('on');
          $('body').addClass('color-scheme-dark');
        }, 100)
        return false;
      }
    }
  },
  created() {
    this.checkDarkMode()
  },
  watch: {
    $route: 'checkDarkMode'
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
